//noScroll
class SelectHover {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const SelectLink = document.querySelectorAll('.selectLink');

    SelectLink.forEach(item  => {
      item.addEventListener('mouseover', () => {
        item.classList.add('is-select')

        SelectLink.forEach(subItem => {
          subItem.classList.add("opacity-50")
        })
      });
    });

    SelectLink.forEach(item  => {
      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-select')

        SelectLink.forEach(subItem => {
          subItem.classList.remove("opacity-50")
        })
      });
    });
  }
}
